export default __webpack_public_path__ + "static/media/react-logo.1d61c7d3.webp";